import Image from '@/lib/media/image';
import { cn } from '@/lib/utils';

type LogoVariant = 'full' | 'icon' | 'text' | 'with-clouds';

interface LogoProps {
  variant?: LogoVariant;
  className?: string;
  width?: number;
  height?: number;
  priority?: boolean;
}

const LOGO_SRCS: Record<LogoVariant, string> = {
  full: '/assets/logos/Main_Logo.png',
  icon: '/assets/logos/Balloon_Only.png',
  text: '/assets/logos/Roam_Text_Only.png',
  'with-clouds': '/assets/logos/Balloon_with_clouds.png',
};

const DEFAULT_DIMS: Record<LogoVariant, { width: number; height: number }> = {
  full: { width: 180, height: 85 },
  icon: { width: 40, height: 49 },
  text: { width: 120, height: 46 },
  'with-clouds': { width: 60, height: 50 },
};

export function Logo({ variant = 'full', className, width, height, priority }: LogoProps) {
  const src = LOGO_SRCS[variant];
  const dims = DEFAULT_DIMS[variant];
  const w = width ?? dims.width;
  const h = height ?? dims.height;

  return (
    <Image
      src={src}
      alt="Roam Together"
      className={cn('brand-logo select-none object-contain', className)}
      width={w}
      height={h}
      priority={priority}
      draggable={false}
    />
  );
}
